import { createStore, applyMiddleware } from 'redux';
import bulkRefundReducer from '../reducers/bulkRefundReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(bulkRefundReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
